<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <span class="breadcrumb-link"
            >{{ 'configurationOptionModule.configurationOptions' | translate }}
          </span>
        </li>
        <li class="breadcrumb-item active">
          {{ 'general.create' | translate }}
        </li>
      </ol>
    </nav>
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'general.create' | translate }}
        {{ 'configurationOptionModule.configurationOption' | translate }}
      </h1>
    </div>
  </header>
  <!-- End Page Header -->

  <section class="card">
    <div class="card-header">
      <h3 class="card-title">
        {{ 'general.create' | translate }}
        {{ 'configurationOptionModule.configurationOption' | translate }}
      </h3>
    </div>
    <div class="card-body">
      <div>
        <configuration-option-form
          (onSubmit)="onSubmit($event)"
          (onPatch)="onPatch($event)"
        >
        </configuration-option-form>
      </div>
    </div>
  </section>
</div>
